import { createRouter, createWebHistory } from 'vue-router';
import { store } from '@/store'

import Home from '@/components/Home'
import CGU from '@/components/Pages/CGU'
import CancellationPolicy from '@/components/Pages/CancellationPolicy'
import PrivacyPolicy from '@/components/Pages/PrivacyPolicy'
import FAQ from '@/components/Pages/FAQ'
import Contact from '@/components/Pages/Contact'

import Login from '@/components/Auth/Login'
import SocialCallback from '@/components/Auth/Login/SocialCallback'
import Register from '@/components/Auth/Register'
import BecomePartner from '@/components/Auth/Register/Vendor'
import OTP from '@/components/Auth/OTP'

import ChangePassword from '@/components/ChangePassword'
import Dashboard from '@/components/DashboardWrapper'
import Notifications from '@/components/Notifications'
import ProfileSettings from '@/components/ProfileSettings'

import Teams from '@/components/Customers/Teams'
import NewTeam from '@/components/Customers/Teams/New'
import EditTeam from '@/components/Customers/Teams/Edit'
import ViewTeam from '@/components/Customers/Teams/View'
import ViewTeamPublic from  '@/components/Pages/Team'

import Matches from '@/components/Customers/Matches'
import OpenChallenges from '@/components/Customers/OpenChallenges'
import Standings from '@/components/Customers/Standings'
import EditMatch from '@/components/Customers/Matches/Edit'
import ViewMatchPublic from  '@/components/Pages/Match'

import PlayerProfile from '@/components/Customers/PlayerProfile'

import Establishments from '@/components/Vendors/Establishments'
import OwnerEstablishment from '@/components/Vendors/Establishments/Owner'
import NewFacility from '@/components/Vendors/Establishments/Facilities/New'
import EditFacility from '@/components/Vendors/Establishments/Facilities/Edit'
import Calendar from '@/components/Vendors/Calendar'
import CalendarV2 from '@/components/Vendors/Calendar/v2'
import Funds from '@/components/Vendors/Funds'
import AdminUsers from '@/components/Vendors/Users'
import AdminMatches from '@/components/Admin/Matches'
import AdminMatchEdit from '@/components/Admin/Matches/Edit'

import Search from '@/components/Pages/Search'
import BookFacility from '@/components/Pages/BookFacility'
import EstablishmentDetail from '@/components/Pages/Establishment'

import Booking from '@/components/Pages/Booking'
import BookingApproval from '@/components/Pages/Booking/Approval'
import UpcomingBookingConfirmation from '@/components/Pages/Booking/UpcomingConfirmation'
import BookingProcessing from '@/components/Pages/Booking/Processing'
import BookingSuccess from '@/components/Pages/Booking/Success'
import BookingFailure from '@/components/Pages/Booking/Failure'

import NotFound from '@/components/Pages/NotFound'
import Coupon10 from '@/components/Pages/Coupon10'
import Coupon8 from '@/components/Pages/Coupon8'
import Components from '@/components/Pages/Components'

import ForgotPassword from '@/components/Auth/Password/Forgot'
import ResetPassword from '@/components/Auth/Password/Reset'

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/index',
        name: 'home-index',
        component: Home
    },
    {
        path: '/cgu',
        name: 'cgu',
        component: CGU
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy
    },
    {
        path: '/cancellation-policy',
        name: 'cancellation-policy',
        component: CancellationPolicy
    },
    {
        path: '/faq',
        name: 'faq',
        component: FAQ
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/login/callback',
        name: 'socialCallback',
        component: SocialCallback,
        props: (route) => ({
            code: route.query.code,
            state: route.query.state,
            scope: route.query.scope,
            error: route.query.error
        })
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/become-partner',
        name: 'become-partner',
        component: BecomePartner
    },
    {
        path: '/otp-verification',
        name: 'otp-verification',
        component: OTP,
        meta: { requiresAuth: true }
    },
    {
        path: '/my',
        children: [
            {
                path: 'bookings',
                name: 'bookings',
                component: Dashboard,
                meta: { requiresAuth: true }
            },
            {
                path: 'notifications',
                name: 'notifications',
                component: Notifications,
                meta: { requiresAuth: true }
            },
            // Vendor routes
            {
                path: 'establishments',
                name: 'establishments',
                component: Establishments,
                meta: { requiresAuth: true, role: ['admin', 'moderator'] }
            },
            {
                path: 'establishment',
                name: 'owner-establishment',
                component: OwnerEstablishment,
                meta: { requiresAuth: true, role: ['owner'] }
            },
            {
                path: 'establishment/:id',
                name: 'establishment',
                component: OwnerEstablishment,
                props: true,
                meta: { requiresAuth: true, role: ['admin'] }
            },
            {
                path: 'establishment/facility',
                name: 'new-owner-facility',
                component: NewFacility,
                meta: { requiresAuth: true, role: ['owner'] }
            },
            {
                path: 'establishment/:establishment_id/facility',
                name: 'new-facility',
                component: NewFacility,
                props: true,
                meta: { requiresAuth: true, role: ['admin'] }
            },
            {
                path: 'establishment/facility/:facility_id',
                name: 'edit-facility',
                component: EditFacility,
                props: true,
                meta: { requiresAuth: true, role: ['admin','owner'] }
            },
            {
                name: 'calendar',
                path: 'calendar',
                component: Calendar,
                meta: { requiresAuth: true, role: ['owner', 'admin', 'moderator'] }
            },
            {
                name: 'calendarV2',
                path: 'calendar/v2',
                component: CalendarV2,
                meta: { requiresAuth: true, role: ['owner', 'admin', 'moderator'] }
            },
            {
                name: 'funds',
                path: 'funds',
                component: Funds,
                meta: { requiresAuth: true, role: ['owner', 'admin', 'moderator'] }
            },
            {
                name: 'admin-users',
                path: 'users',
                component: AdminUsers,
                meta: { requiresAuth: true, role: ['admin'] }
            },
            // User Routes
            {
                path: 'profile',
                name: 'profile',
                component: ProfileSettings,
                meta: { requiresAuth: true, role: ['player', 'owner'] }
            },
            {
                path: 'change-password',
                name: 'change-password',
                component: ChangePassword,
                meta: { requiresAuth: true, role: ['owner', 'player'] }
            },
            // Customer Routes
            {
                path: 'player-profile',
                name: 'player-profile',
                component: PlayerProfile,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'teams',
                name: 'teams',
                component: Teams,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'teams/new',
                name: 'add-team',
                component: NewTeam,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'teams/:id',
                name: 'view-team',
                component: ViewTeam,
                props: true,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'teams/:id/edit',
                name: 'edit-team',
                component: EditTeam,
                props: true,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'standing',
                name: 'standing',
                component: Standings,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'matches',
                name: 'matches',
                component: Matches,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'challenges',
                name: 'open-challenges',
                component: OpenChallenges,
                meta: { requiresAuth: true, role: ['player'] }
            },
            {
                path: 'matches/:id',
                name: 'edit-match',
                component: EditMatch,
                props: true,
                meta: { requiresAuth: true, role: ['player'] }
            }
            ,
            {
                path: 'admin/matches',
                name: 'admin-matches',
                component: AdminMatches,
                meta: { requiresAuth: true, role: ['admin','moderator'] }
            },
            {
                path: 'admin/matches/:id',
                name: 'admin-edit-match',
                component: AdminMatchEdit,
                props: true,
                meta: { requiresAuth: true, role: ['admin','moderator'] }
            }
        ]
    },
    {
        path: '/reset-password/',
        name: 'ResetPassword',
        component: ResetPassword,
        props: route => ({ token: route.query.token })
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/search',
        name: 'search',
        component: Search
    },
    {
        path: '/book/facility/:id([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}):slug(.*)',
        name: 'book-facility',
        component: BookFacility,
        meta: { requiresAuth: false },
        props: true,
    },
    {
        path: '/partner/:id([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}):slug(.*)',
        name: 'partner',
        component: EstablishmentDetail,
        meta: { requiresAuth: false },
        props: true,
    },
    {
        path: '/booking/:id',
        name: 'booking',
        component: Booking,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/bookingApproval/:id',
        redirect: to => { return { name: 'booking-approval', params: { id: to.params.id } } }
    },
    {
        path: '/booking-approval/:id',
        name: 'booking-approval',
        component: BookingApproval,
        props: true,
        meta: { requiresAuth: false }
    },
    {
        path: '/upcoming-booking-confirmation/:id',
        name: 'upcoming-booking-confirmation',
        component: UpcomingBookingConfirmation,
        props: true,
        meta: { requiresAuth: false }
    },
    {
        path: '/booking/:id/success',
        name: 'booking-success',
        component: BookingSuccess,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/booking/:id/failure',
        name: 'booking-failure',
        component: BookingFailure,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/booking/:id/processing',
        name: 'booking-proccesing',
        component: BookingProcessing,
        props: true,
        meta: { requiresAuth: true }
    },
    // {
    //     path: '/get-free-coupon-10',
    //     name: 'coupon-10',
    //     component: Coupon10
    // },
    {
        path: '/get-free-coupon-8',
        name: 'coupon-8',
        component: Coupon8
    },
    {
        path: '/match/:id',
        name: 'match-public',
        component: ViewMatchPublic,
        meta: { requiresAuth: false },
        props: true,
    },
    {
        path: '/team/:id',
        name: 'team-public',
        component: ViewTeamPublic,
        meta: { requiresAuth: false },
        props: true,
    },
    {
        path: '/404',
        name: 'not-found',
        component: NotFound
    },
    {
        path: '/components',
        name: 'components',
        component: Components
    },
    {
        path: '/:catchAll(.*)',
        component: NotFound
    },
];

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Always scroll to top
        return { left: 0, top: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    const isAuthenticated = store.getters.isLoggedIn;
    const isVerified = store.getters.currentUser && store.getters.currentUser.is_verified;
    const userRole = store.getters.currentUser && store.getters.currentUser.role;
    // console.log('Navigating to:', to.name);
    // console.log('User authenticated:', isAuthenticated);
    // console.log('User role:', userRole);
    // Redirect to login if route requires authentication and user is not authenticated
    if (to.meta.requiresAuth && !isAuthenticated) {
        return next({
            name: 'login',
            query: { redirect: to.fullPath }
        });
    } else {
        await store.dispatch('fetchUser');
    }

    if (to.meta.requiresAuth && isAuthenticated && !isVerified && to.name === 'booking') {
        return next({ name: 'otp-verification' });
    }
    
    if (isVerified && to.name === 'otp-verification') {
        return next({ name: 'home' });
    }

    // // Redirect to venues if already logged in and trying to access login or register
    if (isAuthenticated && (to.name === 'login' || to.name === 'register' || to.name === 'become-partner')) {
        return next({ name: 'home' });
    }

    // // Redirect to venues if the route requires a specific role and user lacks it
    if (isAuthenticated && userRole=='owner' && (to.name === 'search' || to.name === 'detail-field')) {
        return next({ name: 'calendar' });
    }

    // // Redirect to venues if the route requires a specific role and user lacks it
    if (to.meta.role && isAuthenticated && (userRole !== null && !to.meta.role.includes(userRole))) {
        return next({ name: 'home' });
    }

    $('.modal').modal('hide')
    $('.alert-modal').modal('hide')

    // Proceed to next route
    next();
});



export default router;
